import clsx from 'clsx';
import ExternalFunnel from 'components/Shared/ExternalFunnel/ExternalFunnel';
import { hideConversionBarUntilScroll } from 'utils/hideConversionBarUntilScroll';
import styles from './FunnelBlock.module.scss';
import type { IBlockFunnel } from 'types/contentful/generated';

type Props = {
  funnel: IBlockFunnel;
  funnelPosition?: 'left' | 'right';
  showHeadline?: boolean;
  wrapperClasses?: string;
  funnelClasses?: string;
};

const FunnelBlock = ({
  funnel,
  funnelPosition = 'right',
  showHeadline,
  wrapperClasses,
  funnelClasses,
}: Props): JSX.Element | null => {
  if (!funnel) {
    return null;
  }

  return (
    <div className={clsx(styles.wrapper, wrapperClasses)}>
      <div
        className={clsx(
          styles.funnel,
          funnelPosition !== 'left' && styles.floatRight,
          funnelClasses,
        )}
      >
        <ExternalFunnel
          funnelId={funnel.sys.id}
          containerClasses={styles.funnelContainerClasses}
          showHeadline={showHeadline}
          onInteraction={hideConversionBarUntilScroll}
          useShadow
        />
      </div>
    </div>
  );
};

export default FunnelBlock;
